// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"149":"2e929148","275":"e992a0c6","454":"44364733","458":"564a7749","480":"d282e1e1","540":"832b8ebe","670":"236044a7","704":"d917293d","754":"19e2b974","790":"bc4102dd","824":"1a02c23a","864":"22e93f1b","897":"3fd810bf"}[chunkId] + ".chunk.js";
};